import * as React from 'react';
import { Props } from '../core/svg-icon/svg-icon';
import { Previous } from './previous';

const Next: React.FC<Props> = (props) => <Previous {...props} rotate={180} />;

Next.displayName = 'Next';

export default Next;
